module.exports = __webpack_public_path__ + "assets/CSP.e4951c49.png";